import React, { Component } from "react";
import { Table, Button, Col, Row, Icon, Tooltip, Drawer, Divider } from "antd";
import Colors from '../utils/Colors';
import { getUsuario } from "../utils/LoginManager";
import numeral from "numeral";

class UsuarioDrawer extends Component {
    state = {
        visible: false,
        childrenDrawer: false
    };

    componentDidMount() {
        const usuario = getUsuario();
        this.setState({
            usuario,
        });
    }

    showDrawer = () => {
        this.setState({
            visible: true,
        });
    };

    onClose = () => {
        this.setState({
            visible: false,
        });
    };

    showChildrenDrawer = () => {
        this.setState({
            childrenDrawer: true,
        });
    };

    onChildrenDrawerClose = () => {
        this.setState({
            childrenDrawer: false,
        });
    };

    render() {
        const { placement, visible, usuario } = this.state;

        // console.log('UsuarioDrawer: ', usuario);

        return (
            <div>
                <Tooltip title="Perfil do Usuário" placement="bottomLeft">
                    <span style={{ cursor: 'pointer' }} onClick={this.showDrawer}>
                        <Icon type="user" />
                    </span>
                </Tooltip>

                <Drawer
                    title="Perfil do Usuário"
                    placement={placement}
                    closable={false}
                    onClose={this.onClose}
                    visible={visible}
                    key={placement}
                    width={"40%"}
                >
                    <Tooltip title="Fechar">
                        <span style={{ fontSize: 20, color: Colors.accentLight, float: "right", marginTop: -70, marginRight: 20, cursor: 'pointer' }} onClick={this.onClose}>
                            <Icon type="close" />
                        </span>
                    </Tooltip>


                    <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 7 }}>Dados do Usuário</p>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={24}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Nome: </span> <span> {usuario ? usuario.usu_nome : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={24}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> CPF: </span> <span> {usuario ? usuario.usu_cpf : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={24}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Telefone: </span> <span> {usuario ? usuario.usu_telefone : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={24}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Email: </span> <span> {usuario ? usuario.usu_email : ''} </span>
                        </Col>
                    </Row>



                    <Divider />



                    <p style={{ fontSize: 25, fontWeight: "bold", marginBottom: 7 }}>Dados da Empresa</p>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={12}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> CPF/CNPJ: </span> <span> {usuario ? usuario.emp_cpf_cnpj : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={24}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Nome: </span> <span> {usuario ? usuario.emp_nome : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={24}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Razão Social: </span> <span> {usuario ? usuario.emp_razao_social : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={12}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> CPF/CNPJ: </span> <span> {usuario ? usuario.emp_cpf_cnpj : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={8}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Telefone: </span> <span> {usuario ? usuario.emp_fone1 : ''} </span>
                        </Col>
                        <Col span={8}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Telefone: </span> <span> {usuario ? usuario.emp_fone2 : ''} </span>
                        </Col>
                        <Col span={8}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Telefone: </span> <span> {usuario ? usuario.emp_fone3 : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={12}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Endereço: </span> <span> {usuario ? usuario.emp_endereco : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={12}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Bairro: </span> <span> {usuario ? usuario.emp_bairro : ''} </span>
                        </Col>
                        <Col span={12}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Complemento: </span> <span> {usuario ? usuario.emp_complemento : ''} </span>
                        </Col>
                    </Row>
                    <Row style={{ marginBottom: 4 }}>
                        <Col span={3}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Nº: </span> <span> {usuario ? usuario.emp_numero : ''} </span>
                        </Col>
                        <Col span={12}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> Cidade: </span> <span> {usuario ? usuario.cmun_descricao : ''} </span>
                        </Col>
                        <Col span={3}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> UF: </span> <span> {usuario ? usuario.cuf_sigla : ''} </span>
                        </Col>
                        <Col span={6}>
                            <span style={{ fontSize: 15, fontWeight: "bold" }}> CEP: </span> <span> {usuario ? usuario.emp_cep : ''} </span>
                        </Col>
                    </Row>

                </Drawer>
            </div>
        );
    }
}

export default UsuarioDrawer;



// WEBPACK FOOTER //
// ./src/components/UsuarioDrawer.js